module.exports = __webpack_public_path__ + "img/top-logo.2c9638e9.png";